import { render } from "./CadastroReceitas.vue?vue&type=template&id=8269c568&scoped=true"
import script from "./CadastroReceitas.vue?vue&type=script&lang=js"
export * from "./CadastroReceitas.vue?vue&type=script&lang=js"

import "./CadastroReceitas.vue?vue&type=style&index=0&id=8269c568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8269c568"]])

export default __exports__